export const AustraliaGeoJson = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: {
        name: 'New South Wales',
        code: 'nsw',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [149.976679008, -37.505059998],
            [149.199774592, -37.201188581],
            [148.19494576, -36.796252903500005],
            [148.171868608, -36.710032599],
            [148.217443264, -36.598853093500004],
            [148.124447872, -36.5509798665],
            [148.1213576, -36.4613092935],
            [148.037937728, -36.367561709],
            [148.03494928, -36.1445450785],
            [147.996108192, -36.0479817755],
            [147.708414624, -35.928544813500004],
            [147.555244992, -36.003209796],
            [147.494111808, -35.94354885],
            [147.405018368, -35.943520101],
            [147.352916672, -36.0315811185],
            [147.204327936, -36.0498891255],
            [147.127863392, -36.0185776905],
            [146.945681568, -36.1155164325],
            [146.655917632, -36.0261953985],
            [146.607971776, -35.9859036565],
            [146.425428352, -35.964049144],
            [146.367258112, -36.0503922515],
            [146.281611232, -36.023973567],
            [146.178902176, -36.038440715],
            [146.032803008, -35.9947739625],
            [145.989126368, -36.0130791575],
            [145.908007328, -35.953564583500004],
            [145.793445088, -35.9828173755],
            [145.685361824, -35.930691461],
            [145.532390208, -35.804858531],
            [145.411000384, -35.848345815],
            [145.284146272, -35.8565720435],
            [145.113922688, -35.8205883595],
            [144.97079536, -35.861048729],
            [144.923615328, -35.9889508285],
            [144.84242016, -36.0998710195],
            [144.726378688, -36.1177811655],
            [144.692392288, -36.069350589],
            [144.583274848, -36.0390252225],
            [144.415773312, -35.909057746],
            [144.377175616, -35.794499715],
            [144.162350656, -35.671525682500004],
            [144.10491808, -35.5907240835],
            [143.98938576, -35.553192430500005],
            [143.764718176, -35.39336662],
            [143.642338272, -35.401037219500004],
            [143.563748, -35.3161190005],
            [143.564473248, -35.236094235],
            [143.396379296, -35.193113333],
            [143.333229248, -35.0463705745],
            [143.321388736, -34.888459699],
            [143.359390752, -34.8172890705],
            [143.104117728, -34.694001167],
            [143.039468128, -34.7026107895],
            [142.78663984, -34.5842586675],
            [142.704206784, -34.612493663500004],
            [142.696761888, -34.720164681],
            [142.526185024, -34.759814473],
            [142.457608, -34.5786749975],
            [142.368407808, -34.5270877475],
            [142.351890752, -34.3947446675],
            [142.248612128, -34.286546233500005],
            [142.243861504, -34.216199595],
            [142.165861184, -34.1522664625],
            [141.983491712, -34.1124118015],
            [141.842403328, -34.132525982],
            [141.704907424, -34.0956858405],
            [141.533031424, -34.2114490355],
            [141.40336368, -34.127204716],
            [141.3135688, -34.1237952955],
            [141.261020512, -34.078979434],
            [141.096691168, -34.073137726],
            [141.002955616, -34.021891967500004],
            [141.00249104, -33.436900933],
            [141.001750656, -32.498500828],
            [141.001288384, -31.81721931],
            [141.000704864, -30.757123559500002],
            [140.999970816, -29.99850022],
            [140.999474528, -28.999095477],
            [141.537022208, -28.99887048],
            [142.363937504, -28.997795704],
            [143.02300896, -28.998851573],
            [143.690278944, -28.999081935],
            [144.356012992, -28.9987754455],
            [144.922320608, -28.9990708535],
            [145.666844, -28.9990809915],
            [146.88676304, -28.999008175500002],
            [147.945490432, -28.999054943500003],
            [148.9583088, -28.999064878],
            [149.031269824, -28.9570636435],
            [149.092764928, -28.834026507500003],
            [149.126554368, -28.835304302500003],
            [149.293635648, -28.711850602],
            [149.38496288, -28.691494145500002],
            [149.455597024, -28.596021954],
            [149.598314432, -28.5792803235],
            [149.672153472, -28.6302597745],
            [150.28964752, -28.537157081500002],
            [150.370044544, -28.620680419],
            [150.46297616, -28.6676947095],
            [150.632541056, -28.6765715645],
            [150.751596704, -28.633423903500002],
            [150.937873856, -28.730447357],
            [151.010298528, -28.740640875500002],
            [151.052376352, -28.84864012],
            [151.103478464, -28.8370467805],
            [151.281944448, -28.949959144],
            [151.281159168, -29.1036954205],
            [151.314761792, -29.1655313005],
            [151.395282496, -29.1771866705],
            [151.502679392, -29.0663698575],
            [151.545415136, -28.953147619],
            [151.72662832, -28.8668760695],
            [151.772735168, -28.93825079],
            [151.916047712, -28.9293071685],
            [152.038126272, -28.8646956965],
            [152.043603296, -28.7306128025],
            [151.955730016, -28.519861616500002],
            [152.016863872, -28.525281228500003],
            [152.069290464, -28.468759066500002],
            [152.217188672, -28.449235554],
            [152.309659456, -28.363168263],
            [152.385080128, -28.3688548855],
            [152.461543968, -28.2609628485],
            [152.536752736, -28.2656944085],
            [152.758138912, -28.3628718745],
            [152.879913632, -28.3096133345],
            [153.109170272, -28.357504321500002],
            [153.184434048, -28.246208895],
            [153.339580384, -28.2503105855],
            [153.485949248, -28.1570278505],
            [153.552171232, -28.164408481],
            [153.586296, -28.258205997],
            [153.552906016, -28.527830991],
            [153.629864, -28.649348999500003],
            [153.595812, -28.7752530065],
            [153.607074016, -28.8428140075],
            [153.441451392, -29.0652879405],
            [153.448331968, -29.150441757],
            [153.351028416, -29.2796911745],
            [153.375905792, -29.367059885],
            [153.356113248, -29.5301931625],
            [153.292056896, -29.7533488575],
            [153.261772544, -29.939942318],
            [153.197636896, -30.038951376500002],
            [153.200734464, -30.157780058500002],
            [153.137456608, -30.3149320455],
            [153.031711008, -30.4990169985],
            [152.991875008, -30.696939008],
            [153.011463008, -30.856409008],
            [153.090714016, -30.9215629925],
            [153.038898016, -31.003685991],
            [153.064587008, -31.056919001],
            [152.984896352, -31.1546988085],
            [152.972992256, -31.3181980715],
            [152.922053856, -31.388373437],
            [152.93502448, -31.475788379],
            [152.852302016, -31.560570993],
            [152.747090464, -31.8450331165],
            [152.635928576, -31.920313594],
            [152.5438024, -32.036143315],
            [152.513898784, -32.1784570625],
            [152.570864256, -32.2155967745],
            [152.5267864, -32.280044410500004],
            [152.53309424, -32.44309799],
            [152.327604928, -32.5334268115],
            [152.186232992, -32.682627998],
            [152.068787008, -32.6895639995],
            [151.972688896, -32.6587010415],
            [152.0073, -32.795741993],
            [151.810110144, -32.878220136],
            [151.728728992, -33.010650998500005],
            [151.591361056, -33.0674550265],
            [151.652298016, -33.102613],
            [151.621948, -33.1975360005],
            [151.441148896, -33.308967957],
            [151.487220992, -33.392845995],
            [151.421450016, -33.518451005],
            [151.284798016, -33.572214003],
            [151.304768992, -33.635268996],
            [151.290192, -33.7990139945],
            [151.228883008, -33.8610910035],
            [151.285384992, -33.8921019985],
            [151.25016, -33.997574994],
            [151.168032992, -33.949773991],
            [151.17162, -34.0815320085],
            [150.99328, -34.2279820045],
            [150.925498016, -34.321238007],
            [150.896196, -34.451636034],
            [150.832914112, -34.487072007],
            [150.885581344, -34.605901355],
            [150.822899008, -34.773159004],
            [150.762336, -34.817196996],
            [150.760348992, -34.992210992],
            [150.679424992, -35.023881993],
            [150.700488608, -35.1230396805],
            [150.604377856, -35.1543133755],
            [150.478280992, -35.2915080065],
            [150.478544352, -35.3678447045],
            [150.391113024, -35.468995064],
            [150.407670016, -35.5296159935],
            [150.32256, -35.613879997],
            [150.305023008, -35.679960998],
            [150.150243008, -35.8911389975],
            [150.160688, -36.0135019935],
            [150.124968, -36.158294001],
            [150.137479008, -36.304734007],
            [150.066660992, -36.3989950035],
            [150.068202016, -36.554269999],
            [149.995503008, -36.673988993500004],
            [149.904521664, -36.9279776395],
            [149.939396992, -37.038900994],
            [149.872976, -37.082264994],
            [150.005088, -37.141713005],
            [149.949831008, -37.374669001],
            [149.976679008, -37.505059998],
          ],
          [
            [148.804045472, -35.7139670135],
            [148.89777568, -35.794650157],
            [148.912654464, -35.8554600825],
            [149.046080448, -35.920762215],
            [149.100583264, -35.814811198],
            [149.109483008, -35.696639599],
            [149.078042688, -35.5861274995],
            [149.14048576, -35.5882919995],
            [149.13866688, -35.428319114],
            [149.249307616, -35.330127219],
            [149.271627616, -35.270804786],
            [149.120901888, -35.124517275500004],
            [148.810040608, -35.3074120495],
            [148.762674816, -35.495504879500004],
            [148.804045472, -35.7139670135],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Victoria',
        code: 'vic',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [145.276440832, -38.3889843],
              [145.290272032, -38.2836699975],
              [145.45355904, -38.307291038],
              [145.35255168, -38.4200485195],
              [145.276440832, -38.3889843],
            ],
          ],
          [
            [
              [140.965735136, -38.055988999],
              [140.973872256, -37.462093082],
              [140.969320192, -36.7930465575],
              [140.963103424, -35.748534578],
              [140.965621344, -35.0082573555],
              [140.961681984, -34.0958184115],
              [141.002955616, -34.021891967500004],
              [141.096691168, -34.073137726],
              [141.261020512, -34.078979434],
              [141.3135688, -34.1237952955],
              [141.40336368, -34.127204716],
              [141.533031424, -34.2114490355],
              [141.704907424, -34.0956858405],
              [141.842403328, -34.132525982],
              [141.983491712, -34.1124118015],
              [142.165861184, -34.1522664625],
              [142.243861504, -34.216199595],
              [142.248612128, -34.286546233500005],
              [142.351890752, -34.3947446675],
              [142.368407808, -34.5270877475],
              [142.457608, -34.5786749975],
              [142.526185024, -34.759814473],
              [142.696761888, -34.720164681],
              [142.704206784, -34.612493663500004],
              [142.78663984, -34.5842586675],
              [143.039468128, -34.7026107895],
              [143.104117728, -34.694001167],
              [143.359390752, -34.8172890705],
              [143.321388736, -34.888459699],
              [143.333229248, -35.0463705745],
              [143.396379296, -35.193113333],
              [143.564473248, -35.236094235],
              [143.563748, -35.3161190005],
              [143.642338272, -35.401037219500004],
              [143.764718176, -35.39336662],
              [143.98938576, -35.553192430500005],
              [144.10491808, -35.5907240835],
              [144.162350656, -35.671525682500004],
              [144.377175616, -35.794499715],
              [144.415773312, -35.909057746],
              [144.583274848, -36.0390252225],
              [144.692392288, -36.069350589],
              [144.726378688, -36.1177811655],
              [144.84242016, -36.0998710195],
              [144.923615328, -35.9889508285],
              [144.97079536, -35.861048729],
              [145.113922688, -35.8205883595],
              [145.284146272, -35.8565720435],
              [145.411000384, -35.848345815],
              [145.532390208, -35.804858531],
              [145.685361824, -35.930691461],
              [145.793445088, -35.9828173755],
              [145.908007328, -35.953564583500004],
              [145.989126368, -36.0130791575],
              [146.032803008, -35.9947739625],
              [146.178902176, -36.038440715],
              [146.281611232, -36.023973567],
              [146.367258112, -36.0503922515],
              [146.425428352, -35.964049144],
              [146.607971776, -35.9859036565],
              [146.655917632, -36.0261953985],
              [146.945681568, -36.1155164325],
              [147.127863392, -36.0185776905],
              [147.204327936, -36.0498891255],
              [147.352916672, -36.0315811185],
              [147.405018368, -35.943520101],
              [147.494111808, -35.94354885],
              [147.555244992, -36.003209796],
              [147.708414624, -35.928544813500004],
              [147.996108192, -36.0479817755],
              [148.03494928, -36.1445450785],
              [148.037937728, -36.367561709],
              [148.1213576, -36.4613092935],
              [148.124447872, -36.5509798665],
              [148.217443264, -36.598853093500004],
              [148.171868608, -36.710032599],
              [148.19494576, -36.796252903500005],
              [149.199774592, -37.201188581],
              [149.976679008, -37.505059998],
              [149.73866288, -37.585749413],
              [149.673772896, -37.686358925],
              [149.470364096, -37.7696343255],
              [148.80873312, -37.7864171],
              [148.704555488, -37.801971234],
              [148.366202976, -37.8039483845],
              [148.179178272, -37.831635392],
              [147.806528928, -37.947366064],
              [147.62856128, -38.045720278],
              [147.467159328, -38.1591477],
              [147.067248064, -38.475119005],
              [146.931966016, -38.596015987],
              [146.815571168, -38.611790012],
              [146.693756896, -38.6757369825],
              [146.649417856, -38.663822964],
              [146.418095552, -38.70607282],
              [146.350705504, -38.6729202095],
              [146.23136, -38.6897633125],
              [146.18885808, -38.7315201435],
              [146.26558624, -38.80530793],
              [146.291917632, -38.9042809875],
              [146.417005888, -38.848922401500005],
              [146.487307264, -38.906146916],
              [146.436677312, -38.979072473],
              [146.483425984, -39.060645633],
              [146.420916992, -39.1258532305],
              [146.345817824, -39.125384237],
              [146.343488768, -39.0605153005],
              [146.184202048, -38.869508665],
              [146.063194336, -38.8117726255],
              [145.936722976, -38.897542973],
              [145.87146352, -38.779443228],
              [145.762226144, -38.664627825],
              [145.650871072, -38.6780910335],
              [145.56052512, -38.6512360265],
              [145.49322816, -38.563864023],
              [145.423688032, -38.536478991],
              [145.432868, -38.4287089985],
              [145.518864128, -38.413709994],
              [145.55245104, -38.354565956500004],
              [145.45229184, -38.218803022],
              [145.251028096, -38.246684039],
              [145.024670176, -38.482869968500005],
              [144.886671008, -38.477248022],
              [144.83694816, -38.370403973],
              [144.975002048, -38.3269699875],
              [145.121339904, -38.133394738],
              [145.09060912, -38.0149521325],
              [145.030676608, -37.994520899],
              [144.97031, -37.860786989],
              [144.897148064, -37.842552057],
              [144.799169504, -37.9231704875],
              [144.650177376, -38.002018209],
              [144.592488384, -38.0045805515],
              [144.48743088, -38.078279871],
              [144.397942944, -38.073816413],
              [144.356117056, -38.138401985],
              [144.480661728, -38.1644900745],
              [144.635493952, -38.107728004500004],
              [144.71963024, -38.173255578],
              [144.62535312, -38.2568290135],
              [144.435686016, -38.281304162],
              [144.285698176, -38.3676010195],
              [144.036497472, -38.4757750705],
              [143.973078112, -38.566362966],
              [143.842061888, -38.679078952],
              [143.685371168, -38.7353600035],
              [143.555650912, -38.854937972500004],
              [143.357883136, -38.7543840345],
              [143.257755968, -38.7706030215],
              [143.010537856, -38.6237999715],
              [142.87437984, -38.6099466905],
              [142.56331872, -38.4220043765],
              [142.372204928, -38.3494179615],
              [142.144815008, -38.390609858],
              [141.88489136, -38.2662928735],
              [141.70361296, -38.259333821],
              [141.59921968, -38.321074074500004],
              [141.648957152, -38.3910551715],
              [141.40672208, -38.369341222],
              [141.357439584, -38.274597634500005],
              [141.227775872, -38.1706485765],
              [140.965735136, -38.055988999],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Queensland',
        code: 'qld',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [142.131994912, -10.0718409555],
              [142.182605888, -10.0599110085],
              [142.187847136, -10.148419985],
              [142.133506912, -10.175969963],
              [142.087466176, -10.130111016],
              [142.131994912, -10.0718409555],
            ],
          ],
          [
            [
              [139.42765392, -17.125930897],
              [139.412553824, -17.0821810425],
              [139.505452288, -16.986350728],
              [139.574102272, -17.092070125],
              [139.42765392, -17.125930897],
            ],
          ],
          [
            [
              [153.086934528, -26.951780323],
              [153.130033088, -26.873924035],
              [153.199651584, -27.057441778],
              [153.166968384, -27.099937869],
              [153.086934528, -26.951780323],
            ],
          ],
          [
            [
              [142.331115168, -10.149713246],
              [142.281858976, -10.2593169955],
              [142.186167008, -10.1906000035],
              [142.265886848, -10.1157890375],
              [142.331115168, -10.149713246],
            ],
          ],
          [
            [
              [153.431916288, -27.032345825],
              [153.427005216, -27.1590735445],
              [153.365501504, -27.201244701500002],
              [153.361399584, -27.0610410455],
              [153.431916288, -27.032345825],
            ],
          ],
          [
            [
              [142.14564288, -10.7476939815],
              [142.11160416, -10.6607539715],
              [142.204621888, -10.5948295915],
              [142.27742304, -10.7064829745],
              [142.14564288, -10.7476939815],
            ],
          ],
          [
            [
              [153.539077536, -27.4417462185],
              [153.461553408, -27.655729928],
              [153.421663008, -27.642054136],
              [153.412834368, -27.515934548500002],
              [153.440925952, -27.3923326815],
              [153.539077536, -27.4417462185],
            ],
          ],
          [
            [
              [146.301201152, -18.494057401],
              [146.221822112, -18.4768178615],
              [146.201631488, -18.382738424],
              [146.27622928, -18.3007886595],
              [146.353319456, -18.416417655500002],
              [146.301201152, -18.494057401],
            ],
          ],
          [
            [
              [151.29263808, -23.7070899835],
              [151.302616928, -23.747490006],
              [151.214879872, -23.794575022],
              [151.120389952, -23.661649987500002],
              [151.04641104, -23.621151952],
              [151.03254096, -23.570402049],
              [150.9794672, -23.4887934985],
              [151.053910912, -23.447802956],
              [151.158328928, -23.5100519965],
              [151.23522816, -23.493582001500002],
              [151.225617952, -23.609492012500002],
              [151.29263808, -23.7070899835],
            ],
          ],
          [
            [
              [139.190302528, -16.665797491],
              [139.160633408, -16.6102233985],
              [139.255301792, -16.496643111],
              [139.315371008, -16.4595528865],
              [139.46538944, -16.446072121500002],
              [139.546518304, -16.391701805500002],
              [139.606207808, -16.4045214545],
              [139.701827424, -16.487970718],
              [139.596688768, -16.5542111705],
              [139.576548672, -16.500961418],
              [139.480729792, -16.524371836],
              [139.451260864, -16.666261693],
              [139.39308128, -16.637272082],
              [139.288072928, -16.734422464],
              [139.230023456, -16.731152811],
              [139.190302528, -16.665797491],
            ],
          ],
          [
            [
              [153.04861216, -25.326308866],
              [153.030724192, -25.175516883],
              [153.163265536, -25.0806462745],
              [153.217868096, -25.0038491115],
              [153.22450896, -24.90914097],
              [153.122564896, -24.804485008500002],
              [153.266298112, -24.6996109875],
              [153.265290112, -24.8771860125],
              [153.357891136, -25.0089170385],
              [153.142123712, -25.475520505],
              [153.07867584, -25.6661199925],
              [153.07766208, -25.792340035],
              [152.995605856, -25.731862018],
              [152.951004, -25.551935014],
              [153.04861216, -25.326308866],
            ],
          ],
          [
            [
              [152.936304992, -25.7435919985],
              [153.164189152, -25.949647977],
              [153.0676344, -26.265075789],
              [153.068584352, -26.361971518500003],
              [153.114762976, -26.397363961],
              [153.0927, -26.531838981],
              [153.108486016, -26.6703910125],
              [153.137060992, -26.6847959635],
              [153.112183424, -26.869574259500002],
              [153.045258112, -26.9859461045],
              [153.143607552, -27.07444609],
              [153.063654048, -27.114163592],
              [153.029627072, -27.182669517500003],
              [153.088845344, -27.2062780705],
              [153.082601504, -27.3338213255],
              [153.156344352, -27.363693183],
              [153.204019936, -27.479951993],
              [153.259938592, -27.482931455],
              [153.322849088, -27.6991869645],
              [153.391265984, -27.707013093500002],
              [153.424873984, -27.7796146045],
              [153.368741152, -27.8017460065],
              [153.42937824, -27.934792068],
              [153.45036112, -28.083605624],
              [153.552171232, -28.164408481],
              [153.485949248, -28.1570278505],
              [153.339580384, -28.2503105855],
              [153.184434048, -28.246208895],
              [153.109170272, -28.357504321500002],
              [152.879913632, -28.3096133345],
              [152.758138912, -28.3628718745],
              [152.536752736, -28.2656944085],
              [152.461543968, -28.2609628485],
              [152.385080128, -28.3688548855],
              [152.309659456, -28.363168263],
              [152.217188672, -28.449235554],
              [152.069290464, -28.468759066500002],
              [152.016863872, -28.525281228500003],
              [151.955730016, -28.519861616500002],
              [152.043603296, -28.7306128025],
              [152.038126272, -28.8646956965],
              [151.916047712, -28.9293071685],
              [151.772735168, -28.93825079],
              [151.72662832, -28.8668760695],
              [151.545415136, -28.953147619],
              [151.502679392, -29.0663698575],
              [151.395282496, -29.1771866705],
              [151.314761792, -29.1655313005],
              [151.281159168, -29.1036954205],
              [151.281944448, -28.949959144],
              [151.103478464, -28.8370467805],
              [151.052376352, -28.84864012],
              [151.010298528, -28.740640875500002],
              [150.937873856, -28.730447357],
              [150.751596704, -28.633423903500002],
              [150.632541056, -28.6765715645],
              [150.46297616, -28.6676947095],
              [150.370044544, -28.620680419],
              [150.28964752, -28.537157081500002],
              [149.672153472, -28.6302597745],
              [149.598314432, -28.5792803235],
              [149.455597024, -28.596021954],
              [149.38496288, -28.691494145500002],
              [149.293635648, -28.711850602],
              [149.126554368, -28.835304302500003],
              [149.092764928, -28.834026507500003],
              [149.031269824, -28.9570636435],
              [148.9583088, -28.999064878],
              [147.945490432, -28.999054943500003],
              [146.88676304, -28.999008175500002],
              [145.666844, -28.9990809915],
              [144.922320608, -28.9990708535],
              [144.356012992, -28.9987754455],
              [143.690278944, -28.999081935],
              [143.02300896, -28.998851573],
              [142.363937504, -28.997795704],
              [141.537022208, -28.99887048],
              [140.999474528, -28.999095477],
              [140.99570208, -28.0691832645],
              [140.996764448, -27.2852294475],
              [140.999438624, -26.734048328500002],
              [140.999394304, -25.9963764425],
              [139.74206192, -25.9965552635],
              [139.070739008, -25.996693366],
              [137.999053824, -25.99686697],
              [137.998899296, -25.416447859],
              [137.99870368, -24.666468885],
              [137.99854816, -24.083167992],
              [137.998402752, -23.499857294],
              [137.998004064, -22.5792390375],
              [137.997568288, -21.8396459635],
              [137.99720352, -21.2563357465],
              [137.99659712, -20.2563765585],
              [137.996242208, -19.602136768],
              [137.996615616, -18.868219272],
              [138.00119696, -18.646506318],
              [138.001195744, -17.822506735],
              [138.00119728, -17.210267402],
              [138.001180288, -16.5445094745],
              [138.116736736, -16.6480193425],
              [138.323615296, -16.7504579865],
              [138.427903552, -16.77725729],
              [138.632709408, -16.768966034],
              [138.898707584, -16.883904332500002],
              [139.000206656, -16.89217374],
              [139.086946464, -16.9987330555],
              [139.157925952, -17.029232599500002],
              [139.155046944, -17.1638923605],
              [139.247580128, -17.32729115],
              [139.341510336, -17.3745803875],
              [139.417409792, -17.374599905],
              [139.532150176, -17.438868942],
              [139.650580352, -17.5372379005],
              [139.821767808, -17.570616932500002],
              [139.935966592, -17.629726116],
              [139.982906816, -17.704755604],
              [140.093434816, -17.7225449265],
              [140.378211424, -17.6797132825],
              [140.630438432, -17.5747619315],
              [140.70983728, -17.5099315305],
              [140.827306272, -17.4584507295],
              [140.895034816, -17.3472605495],
              [140.950402528, -17.150770699],
              [140.973590336, -16.9698411985],
              [141.064848704, -16.8702408245],
              [141.08228784, -16.80316099],
              [141.140817152, -16.768830632500002],
              [141.221185728, -16.656100346],
              [141.233035136, -16.5879804785],
              [141.304973792, -16.459950248],
              [141.287213536, -16.4256905605],
              [141.346621632, -16.2300508405],
              [141.43276992, -16.074760786],
              [141.373378944, -15.916912033500001],
              [141.397568768, -15.909631858],
              [141.423907296, -15.7262524025],
              [141.480175808, -15.498202551],
              [141.632333728, -15.161722109],
              [141.661032992, -14.986262355500001],
              [141.589212736, -14.851553403],
              [141.525609728, -14.487086309],
              [141.603256768, -14.2299875725],
              [141.598821952, -14.109797975],
              [141.468991936, -13.920428978],
              [141.503222176, -13.6576790095],
              [141.550602112, -13.506938993],
              [141.696079936, -13.264538044],
              [141.629493248, -13.1594297945],
              [141.613621952, -13.029790323],
              [141.58316192, -12.996720611],
              [141.633530496, -12.913030496],
              [141.758378368, -12.824619921],
              [141.827326272, -12.648550056],
              [141.822406944, -12.601470183],
              [141.702007488, -12.51957109],
              [141.68683744, -12.5612309995],
              [141.591768352, -12.5639315925],
              [141.732019264, -12.2234020555],
              [141.850440064, -11.9844522445],
              [141.886490272, -11.9832217725],
              [141.932345056, -12.070881007],
              [142.012235168, -12.039110994],
              [141.942845152, -11.976480983],
              [141.977423872, -11.7769730425],
              [141.998132896, -11.76029298],
              [142.051312096, -11.554844042],
              [142.097112, -11.4471839765],
              [142.126829984, -11.3057849615],
              [142.11932112, -11.226465009],
              [142.15728096, -11.121775026],
              [142.125935552, -10.9813752145],
              [142.176735904, -10.921254599],
              [142.284486432, -10.917763260500001],
              [142.351136544, -10.883342604500001],
              [142.438256576, -10.7081624785],
              [142.527724768, -10.694652909],
              [142.60595344, -10.7477729025],
              [142.513195392, -10.860252218],
              [142.591294624, -10.868942075],
              [142.609294464, -10.9338517855],
              [142.726519072, -10.9737410415],
              [142.786058048, -11.074181038],
              [142.783158976, -11.2226699745],
              [142.86827808, -11.3843989725],
              [142.837208992, -11.425548966500001],
              [142.852606912, -11.5878690025],
              [142.856358112, -11.8455180215],
              [142.970258176, -11.9309370355],
              [143.14750416, -11.9193679865],
              [143.185583872, -11.9908179835],
              [143.092949056, -12.1576249725],
              [143.083063072, -12.347415455],
              [143.169501856, -12.346965202],
              [143.27189936, -12.4047354295],
              [143.274826496, -12.508795284],
              [143.438163936, -12.623333742],
              [143.402469312, -12.662274096],
              [143.350597088, -12.888372956],
              [143.544117216, -12.8427732865],
              [143.498778144, -12.95290288],
              [143.503408224, -13.10905213],
              [143.538907936, -13.350420779],
              [143.58136736, -13.373070551],
              [143.586809312, -13.5449755665],
              [143.560068608, -13.586799515500001],
              [143.532090272, -13.7566981135],
              [143.631539552, -13.980036681],
              [143.68011936, -14.012436212],
              [143.698480096, -14.180085376500001],
              [143.745770528, -14.3331143795],
              [143.84684032, -14.462793182],
              [143.948279584, -14.495552334500001],
              [144.095207712, -14.445141962],
              [144.195095936, -14.33828204],
              [144.196065184, -14.2609726305],
              [144.328223712, -14.308211918],
              [144.43475152, -14.2597220675],
              [144.49144976, -14.1660226385],
              [144.596248608, -14.261841816],
              [144.585659936, -14.354521081],
              [144.651098976, -14.358360904],
              [144.61881152, -14.475389906],
              [144.684401408, -14.552839305],
              [144.77507008, -14.547989086],
              [144.781050784, -14.5923686805],
              [144.910229408, -14.614048109],
              [144.950782176, -14.728006814],
              [145.02411152, -14.795106221500001],
              [145.178310848, -14.84319366],
              [145.296417024, -14.9631649575],
              [145.354424864, -14.9825348275],
              [145.276708608, -15.060794286],
              [145.238210144, -15.195553318],
              [145.289156192, -15.311171787500001],
              [145.238646944, -15.440101673],
              [145.31766848, -15.565611038],
              [145.312190048, -15.6420523535],
              [145.361279424, -15.719592180500001],
              [145.362644992, -15.9220109665],
              [145.404318752, -15.9403315905],
              [145.470927328, -16.075891136],
              [145.44127792, -16.1746509995],
              [145.477077344, -16.2752306155],
              [145.416188416, -16.3453106505],
              [145.413278432, -16.466070455],
              [145.470043072, -16.5143790055],
              [145.582089856, -16.687377001],
              [145.672053216, -16.738943938],
              [145.774644832, -16.869675964],
              [145.781051424, -16.9220401955],
              [145.953324288, -16.8898822745],
              [145.90070352, -16.9816810505],
              [145.891975904, -17.0642747815],
              [145.950025568, -17.13273442],
              [146.008791008, -17.322993008],
              [146.0733056, -17.397093204],
              [146.06477648, -17.5076429325],
              [146.148565792, -17.650022022],
              [146.091358528, -17.8047319905],
              [146.11462848, -17.857251714500002],
              [146.094319488, -17.9737813275],
              [146.008031744, -18.1205310235],
              [146.026257856, -18.262519023],
              [146.141122048, -18.36407888],
              [146.225892256, -18.4982777505],
              [146.33752096, -18.525827081],
              [146.337641536, -18.612156665],
              [146.28889312, -18.745696473],
              [146.276093952, -18.854416274],
              [146.338328896, -18.957875045],
              [146.456628128, -19.075064035],
              [146.68889408, -19.1934696775],
              [146.774073952, -19.188627025],
              [146.788016032, -19.237295974],
              [146.881811872, -19.3032600365],
              [146.957786176, -19.3009898645],
              [147.040653216, -19.208042571500002],
              [147.06750576, -19.343021883],
              [147.134743936, -19.407086014],
              [147.246905152, -19.432459985],
              [147.303888128, -19.407672982],
              [147.441008896, -19.4211610175],
              [147.546340928, -19.527134031],
              [147.58680384, -19.725094983],
              [147.676429088, -19.830583981],
              [147.773234176, -19.826567002],
              [147.754562048, -19.7111719755],
              [147.847248, -19.7298160165],
              [147.862268992, -19.844785987],
              [147.938483872, -19.9184769815],
              [148.08010896, -19.881864982],
              [148.111949152, -19.941575045500002],
              [148.267217152, -19.989774002],
              [148.228017856, -20.0354939955],
              [148.342016896, -20.1530230155],
              [148.460365088, -20.1437720165],
              [148.474521152, -20.0645828405],
              [148.56658416, -20.1323709845],
              [148.584063968, -20.196360986],
              [148.660823168, -20.215889993],
              [148.815140032, -20.3207540425],
              [148.839306112, -20.431709994],
              [148.735929952, -20.4817560275],
              [148.663094048, -20.587320006],
              [148.730798176, -20.716657021],
              [148.833079904, -20.7891087375],
              [148.915064896, -20.8919770255],
              [149.017403168, -20.9122059615],
              [149.01421392, -20.990276017],
              [149.159152096, -21.001444023],
              [149.210262016, -21.076973011],
              [149.198474176, -21.2292929645],
              [149.295483008, -21.285502014],
              [149.318972992, -21.3719419875],
              [149.286724928, -21.487231971],
              [149.34418416, -21.475872009],
              [149.376028928, -21.53395287],
              [149.485352032, -21.5717709585],
              [149.43864384, -21.6408909545],
              [149.45953392, -21.728350981],
              [149.435556128, -21.806690045],
              [149.471814976, -21.8397599975],
              [149.46628608, -21.928149982],
              [149.597293408, -22.2814694015],
              [149.658283104, -22.354888853],
              [149.731057088, -22.347776972],
              [149.850875168, -22.418085963],
              [149.912998272, -22.345847348],
              [149.963985408, -22.174227399],
              [150.035443616, -22.12919703],
              [150.15159792, -22.259825012],
              [150.174938176, -22.3550540025],
              [150.298265888, -22.406213976500002],
              [150.446230208, -22.522534077],
              [150.573019072, -22.577263663],
              [150.533072992, -22.4500220135],
              [150.55571088, -22.3234720235],
              [150.668204544, -22.3491527985],
              [150.6932152, -22.430602619],
              [150.749054528, -22.448522237],
              [150.691721056, -22.553582035],
              [150.827303168, -22.6826859685],
              [150.750828, -23.135553],
              [150.792422048, -23.162234033],
              [150.82400016, -23.2795040345],
              [150.78570192, -23.3100929705],
              [150.815084032, -23.416173987],
              [150.871419008, -23.4809430235],
              [150.878143072, -23.5522919735],
              [150.937742176, -23.543602024],
              [151.026550912, -23.572011956],
              [151.043900032, -23.625530014],
              [151.122043616, -23.6722209615],
              [151.171918432, -23.8146068775],
              [151.311709088, -23.852494988500002],
              [151.354824128, -23.935767022],
              [151.507727776, -24.017201913],
              [151.527437568, -24.0637719445],
              [151.610386112, -24.0425016435],
              [151.655469856, -24.086979991],
              [151.769113632, -24.028750575],
              [151.787577952, -24.122969003],
              [151.944517088, -24.2435379615],
              [152.03805696, -24.493746965],
              [152.154460096, -24.631718041],
              [152.29699, -24.723793984],
              [152.377450912, -24.731152026],
              [152.468402048, -24.8172460125],
              [152.491662016, -24.980658029500002],
              [152.56060992, -25.101765985500002],
              [152.63303184, -25.151781956500002],
              [152.66796912, -25.245818992],
              [152.90360208, -25.2826479965],
              [152.90824512, -25.429335995],
              [152.868849888, -25.4470482095],
              [152.909380096, -25.526232631],
              [152.87432288, -25.556209827500002],
              [152.936304992, -25.7435919985],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'South Australia',
        code: 'sa',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [137.934831808, -35.8643465205],
              [137.80394496, -35.851526002],
              [137.607141952, -35.919063008500004],
              [137.586639968, -36.019558986],
              [137.458240928, -36.0682610315],
              [137.371183936, -35.998484045],
              [137.183751008, -35.981367031],
              [137.130460928, -36.033981031],
              [136.85958, -36.017387012],
              [136.757274848, -36.0497060125],
              [136.534610176, -35.886537992],
              [136.58743584, -35.748856977500004],
              [136.783599104, -35.7002549985],
              [137.06853408, -35.668288978],
              [137.312564032, -35.579465002],
              [137.511374048, -35.595315987],
              [137.562954848, -35.5724710215],
              [137.577915008, -35.725671001500004],
              [137.780333984, -35.72393202],
              [137.74416912, -35.805624024],
              [137.796315136, -35.834282004],
              [137.905922176, -35.716941998500005],
              [138.05911296, -35.751959002],
              [138.110892832, -35.848409048],
              [138.040704, -35.904255035],
              [137.934831808, -35.8643465205],
            ],
          ],
          [
            [
              [129.001340096, -31.6870684245],
              [129.001409696, -31.0555227875],
              [129.001390432, -30.4426170475],
              [129.00157248, -29.3889107345],
              [129.001635744, -28.7222675635],
              [129.001693696, -27.9722919565],
              [129.001344448, -27.472308237],
              [129.001336896, -26.8056623835],
              [129.001853696, -25.9986126115],
              [129.81131744, -25.9985797555],
              [130.871560224, -25.998593316],
              [131.498454016, -25.998587803],
              [132.52720848, -25.998577221],
              [132.993366944, -25.998572522],
              [133.947292256, -25.998546659],
              [134.533289984, -25.998543292],
              [135.263283264, -25.998535411],
              [135.877277024, -25.998526975],
              [136.582592864, -25.998043089],
              [137.165896128, -25.997557168],
              [137.999053824, -25.99686697],
              [139.070739008, -25.996693366],
              [139.74206192, -25.9965552635],
              [140.999394304, -25.9963764425],
              [140.999438624, -26.734048328500002],
              [140.996764448, -27.2852294475],
              [140.99570208, -28.0691832645],
              [140.999474528, -28.999095477],
              [140.999970816, -29.99850022],
              [141.000704864, -30.757123559500002],
              [141.001288384, -31.81721931],
              [141.001750656, -32.498500828],
              [141.00249104, -33.436900933],
              [141.002955616, -34.021891967500004],
              [140.961681984, -34.0958184115],
              [140.965621344, -35.0082573555],
              [140.963103424, -35.748534578],
              [140.969320192, -36.7930465575],
              [140.973872256, -37.462093082],
              [140.965735136, -38.055988999],
              [140.842434976, -38.041347951],
              [140.661789856, -38.0610000015],
              [140.375846176, -37.8977619585],
              [140.267053088, -37.709873017],
              [140.113443968, -37.5753020375],
              [140.12084016, -37.530864982],
              [140.01134688, -37.493125019],
              [139.889420992, -37.374509975],
              [139.757523136, -37.1943849655],
              [139.795818112, -37.1374679765],
              [139.742424, -37.024146004500004],
              [139.670318208, -36.958743195],
              [139.850476928, -36.823501979],
              [139.861166816, -36.6871054935],
              [139.787515072, -36.468928981],
              [139.709323072, -36.3124629925],
              [139.59079488, -36.1286000025],
              [139.483940032, -35.9996879695],
              [139.211957152, -35.754559029],
              [139.031909376, -35.635564883],
              [138.890026528, -35.5630844915],
              [138.711492, -35.513427957],
              [138.631521952, -35.543843992],
              [138.522359872, -35.642968028],
              [138.46577904, -35.6302629865],
              [138.15688608, -35.658167036],
              [138.093913088, -35.6034030215],
              [138.165487936, -35.519376965],
              [138.290142976, -35.4724640175],
              [138.341252896, -35.3928639565],
              [138.440354048, -35.3510620225],
              [138.46743216, -35.121283013],
              [138.51729216, -35.0272199665],
              [138.476059936, -34.8567659985],
              [138.55386624, -34.7978336935],
              [138.54059344, -34.7516357895],
              [138.43056624, -34.668154151],
              [138.4068528, -34.599117072],
              [138.263708992, -34.4737027415],
              [138.222353152, -34.31000403],
              [138.15562896, -34.2718589725],
              [138.159024832, -34.209134001],
              [138.06818496, -34.140875032],
              [138.00150288, -34.261605995],
              [138.00709584, -34.3490319815],
              [137.915975168, -34.430804997],
              [137.876118112, -34.5985109935],
              [137.858352128, -34.773944033],
              [137.72687616, -35.0491429845],
              [137.75910912, -35.1143550035],
              [137.637069856, -35.1681209985],
              [137.554817056, -35.117454956],
              [137.424344032, -35.097876998],
              [137.33411616, -35.168066997],
              [137.259806048, -35.1590319855],
              [137.144076832, -35.2433799975],
              [137.001389024, -35.223207024],
              [136.890172096, -35.2987190105],
              [136.829661856, -35.2501270215],
              [136.960044832, -35.089045024],
              [136.936203104, -35.032043971],
              [137.012552992, -34.9204799615],
              [137.27328192, -34.893720988],
              [137.375395904, -34.953726959],
              [137.45707488, -34.8895889945],
              [137.50686, -34.5825440135],
              [137.472087968, -34.397358033],
              [137.499904096, -34.2265040025],
              [137.449598048, -34.1403029935],
              [137.515853152, -34.134830009],
              [137.567396384, -34.043610912],
              [137.53796, -34.0081550145],
              [137.631160096, -33.9188529615],
              [137.600684992, -33.8766399945],
              [137.87902256, -33.596782188],
              [137.964795264, -33.574318156],
              [137.870611936, -33.396821016],
              [137.88076896, -33.3224389725],
              [137.817209888, -33.2864100005],
              [137.83842, -33.207009036500004],
              [138.048044032, -33.135837039],
              [138.018783744, -33.035621096],
              [137.95231552, -33.006411113],
              [137.868763424, -32.675108636],
              [137.764887616, -32.6005431095],
              [137.752329312, -32.720730376],
              [137.809455104, -32.74799649],
              [137.789289248, -32.9152054655],
              [137.61169488, -32.974345988],
              [137.59572816, -33.035157005],
              [137.44252432, -33.151693278],
              [137.37874736, -33.3036231035],
              [137.38421136, -33.377502853500005],
              [137.252282816, -33.608452987],
              [137.167889184, -33.6904394185],
              [136.9916744, -33.7247932155],
              [136.799629056, -33.803330174],
              [136.363136032, -34.0693489815],
              [136.32353664, -34.182375453],
              [136.187841376, -34.334839688],
              [136.131067136, -34.343695823],
              [136.062059872, -34.47983773],
              [135.940782816, -34.520534048500004],
              [135.860502144, -34.6354866105],
              [135.84637344, -34.752881931],
              [135.959995808, -34.8480490205],
              [136.00306208, -34.9765066565],
              [135.943287872, -35.0020801315],
              [135.84704816, -34.880896418],
              [135.751832512, -34.856149523],
              [135.619854624, -34.942477701],
              [135.604502368, -34.878666761],
              [135.47434048, -34.7441080285],
              [135.345293536, -34.680819991],
              [135.336279744, -34.6204934705],
              [135.228510816, -34.543633925500004],
              [135.316158656, -34.520713776],
              [135.385699328, -34.644051648],
              [135.494016128, -34.613291975500005],
              [135.395768576, -34.4968029515],
              [135.344181984, -34.261435517500004],
              [135.278998432, -34.121300848],
              [135.271550688, -34.019590734],
              [135.151286048, -33.858152001],
              [135.021521888, -33.740675003],
              [134.84238928, -33.629753591],
              [134.860612768, -33.505368471],
              [134.801635424, -33.328472766],
              [134.676390368, -33.233186703],
              [134.699667808, -33.1727195085],
              [134.588788224, -33.1401372345],
              [134.449898528, -33.1446118665],
              [134.31697424, -33.193986535],
              [134.19021856, -33.015663666],
              [134.080594624, -32.709572693],
              [134.189614848, -32.742133507],
              [134.287359008, -32.700153048],
              [134.250166368, -32.550424038],
              [134.118535744, -32.453823698],
              [133.991563968, -32.5053529135],
              [133.847144384, -32.5033910625],
              [133.946929856, -32.4115774125],
              [133.901988768, -32.31821707],
              [133.806980128, -32.233614091],
              [133.68298416, -32.1929234705],
              [133.671747744, -32.1073710345],
              [133.600689088, -32.0844924915],
              [133.535392256, -32.1661523055],
              [133.4727904, -32.1001074535],
              [133.267025408, -32.2032176105],
              [133.13996032, -32.179593684],
              [133.051567072, -32.103303421],
              [132.778775136, -31.9594370055],
              [132.531328768, -31.9349445225],
              [132.335282592, -32.029049601],
              [132.176409024, -32.018312737500004],
              [132.112918272, -31.946779139],
              [131.802787072, -31.744870028],
              [131.480196128, -31.587983997],
              [131.244775936, -31.4922770035],
              [131.129566816, -31.464364037],
              [131.02639776, -31.537626294],
              [130.791362048, -31.607000998],
              [130.275062848, -31.573662240500003],
              [129.938354496, -31.588625503],
              [129.832944832, -31.6083466325],
              [129.527783936, -31.6226841695],
              [129.001340096, -31.6870684245],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Western Australia',
        code: 'wa',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [125.129477888, -14.6337630225],
              [125.097447968, -14.559202972],
              [125.178405824, -14.452414016],
              [125.21519712, -14.49750303],
              [125.213118112, -14.6056619665],
              [125.129477888, -14.6337630225],
            ],
          ],
          [
            [
              [124.471464128, -15.373656999],
              [124.50455712, -15.281620017],
              [124.568237152, -15.2882099945],
              [124.622813888, -15.389476016],
              [124.566554144, -15.444255959],
              [124.527293984, -15.367697002],
              [124.471464128, -15.373656999],
            ],
          ],
          [
            [
              [115.318310304, -20.8227206475],
              [115.435609184, -20.665658126500002],
              [115.476918848, -20.7351279945],
              [115.416410816, -20.867089993],
              [115.30778112, -20.8686909645],
              [115.318310304, -20.8227206475],
            ],
          ],
          [
            [
              [112.968555104, -25.7246909925],
              [112.921124032, -25.588189982],
              [113.008803104, -25.557908035],
              [113.126496832, -25.9224319795],
              [113.203608128, -26.002961998500002],
              [113.23641888, -26.091351983],
              [113.209459904, -26.1359829925],
              [113.061857024, -25.9445729645],
              [112.966414912, -25.780311982500002],
              [112.968555104, -25.7246909925],
            ],
          ],
          [
            [
              [129.001241952, -14.879472863],
              [129.000439712, -15.3874385925],
              [129.000486144, -16.199583912],
              [129.000489856, -16.7812583405],
              [129.000496736, -17.372407396],
              [129.000514688, -18.148128269],
              [129.000521536, -19.0839349885],
              [129.001278848, -19.998564536],
              [129.001289344, -20.9985791315],
              [129.001014944, -21.9985755045],
              [129.001301856, -22.9985751705],
              [129.001306112, -23.4319193925],
              [129.000752736, -24.331991216],
              [129.000699648, -24.9153040785],
              [129.001853696, -25.9986126115],
              [129.001336896, -26.8056623835],
              [129.001344448, -27.472308237],
              [129.001693696, -27.9722919565],
              [129.001635744, -28.7222675635],
              [129.00157248, -29.3889107345],
              [129.001390432, -30.4426170475],
              [129.001409696, -31.0555227875],
              [129.001340096, -31.6870684245],
              [128.803352896, -31.757973485500003],
              [128.642334784, -31.850934616500002],
              [128.280599168, -31.990757857],
              [128.054141408, -32.064689185],
              [127.70570512, -32.136701841],
              [127.51881744, -32.214123564],
              [127.213371328, -32.276387275],
              [126.672788544, -32.308370537500004],
              [126.400415488, -32.280084056],
              [126.203139232, -32.2322767445],
              [125.951010112, -32.290542365],
              [125.821764768, -32.3551650665],
              [125.55692928, -32.536011243],
              [125.256752672, -32.630755515],
              [125.102415008, -32.715398028500005],
              [125.026185696, -32.728859017],
              [124.900218144, -32.828561363],
              [124.748630208, -32.898603769],
              [124.458262592, -32.935577499],
              [124.235575328, -33.019850863500004],
              [124.101188736, -33.176153867],
              [123.998940288, -33.423665071],
              [123.980189952, -33.549706237],
              [123.756933728, -33.7230690895],
              [123.758603584, -33.798610287500004],
              [123.590044544, -33.8811410445],
              [123.546755424, -33.9349922135],
              [123.358295808, -33.8990929265],
              [123.286897024, -33.979873916500004],
              [123.179607712, -34.012274742500004],
              [123.139237408, -33.910613746],
              [123.06602752, -33.864753615],
              [122.829388864, -33.909975385],
              [122.600299808, -33.90040626],
              [122.569490208, -33.948006649],
              [122.359190944, -33.9147473305],
              [122.19664176, -34.00719899],
              [122.136742656, -34.006599053500004],
              [122.085381792, -33.9027984765],
              [121.988161888, -33.8283386405],
              [121.915102208, -33.8382585625],
              [121.785954112, -33.9082389935],
              [121.70089296, -33.862268972500004],
              [121.646553824, -33.887367996500004],
              [121.552386624, -33.8294995525],
              [121.361482048, -33.8154416615],
              [121.265612992, -33.850304005],
              [121.008718016, -33.8708527875],
              [120.86871696, -33.856233033],
              [120.807435264, -33.889048185],
              [120.601481856, -33.885885721],
              [120.437279968, -33.9714535675],
              [120.230771104, -33.9323999935],
              [120.118843072, -33.9521020125],
              [120.04405984, -33.923132899500004],
              [119.948166176, -33.974799422],
              [119.850968352, -33.969833393],
              [119.732983616, -34.061149652],
              [119.639280512, -34.0957276875],
              [119.51158128, -34.2635161755],
              [119.48251184, -34.375227889],
              [119.413693056, -34.3742457055],
              [119.402487808, -34.452553079],
              [119.30974496, -34.4455548805],
              [119.28354112, -34.51264489],
              [118.984481504, -34.451004111],
              [118.902651936, -34.50164072],
              [118.806264448, -34.5123907925],
              [118.739220576, -34.5769122065],
              [118.773762688, -34.607860135],
              [118.645734304, -34.691042314],
              [118.519837344, -34.7174512675],
              [118.424549056, -34.77770993],
              [118.402236608, -34.9054878945],
              [118.259285472, -34.9086751115],
              [118.102092256, -34.9860199855],
              [117.8539432, -35.056112064],
              [117.645439552, -35.06061822],
              [117.63349712, -35.129556398],
              [117.397345728, -35.031932712],
              [117.205292288, -35.017042672500004],
              [117.13554304, -35.0548597805],
              [116.956360096, -35.019751535],
              [116.924562976, -35.063707276],
              [116.77645008, -35.015249967],
              [116.635470848, -35.054376523500004],
              [116.49843216, -35.0154511545],
              [116.22760496, -34.868820691],
              [116.032145184, -34.8371053825],
              [115.953801056, -34.727825938],
              [115.800208928, -34.586546044500004],
              [115.586050208, -34.4266506],
              [115.36972096, -34.322581477],
              [115.1681728, -34.3211835985],
              [115.02746496, -34.2567070285],
              [114.995972864, -34.105186978],
              [114.978370656, -33.8701523035],
              [115.000084032, -33.794022472500004],
              [114.974963584, -33.702727618],
              [115.0888776, -33.568611091],
              [115.123127328, -33.623799329],
              [115.30927456, -33.653963986],
              [115.441677152, -33.5950907145],
              [115.59261568, -33.422958408],
              [115.679622752, -33.284992364],
              [115.688765024, -33.120566843],
              [115.6082472, -32.6667189045],
              [115.773898112, -32.635094468],
              [115.718579936, -32.564569323],
              [115.745959904, -32.408679332],
              [115.725795104, -32.276337029],
              [115.775131392, -32.1825859295],
              [115.74757296, -32.0607040445],
              [115.786035616, -32.0117750595],
              [115.748267552, -31.8346687135],
              [115.685782912, -31.653709021],
              [115.539123488, -31.408290296500002],
              [115.44051664, -31.276682092],
              [115.313676, -30.9747612225],
              [115.188270112, -30.784285981],
              [115.057653728, -30.503186991],
              [115.037101088, -30.253196972],
              [114.954861952, -30.048668002],
              [114.982491968, -29.9178170025],
              [114.95924064, -29.669364685],
              [114.996093952, -29.487709577500002],
              [114.926874144, -29.3127323965],
              [114.871996704, -29.1165556585],
              [114.634273344, -28.8735636345],
              [114.596572704, -28.611563175],
              [114.49088496, -28.446476038500002],
              [114.323321152, -28.233061019],
              [114.17471056, -28.1109722855],
              [114.10539872, -27.8503729605],
              [114.151586784, -27.733461063500002],
              [114.151085536, -27.6496700495],
              [114.08601216, -27.4602882135],
              [114.016359456, -27.32080763],
              [113.736696128, -26.8664769895],
              [113.584357088, -26.6714260135],
              [113.296192928, -26.399175037],
              [113.299632, -26.342434982],
              [113.242170944, -26.240502960500002],
              [113.318520832, -26.23912299],
              [113.444179904, -26.166420987],
              [113.478631904, -26.3082020455],
              [113.52632112, -26.283141002],
              [113.559482144, -26.353482035],
              [113.57707392, -26.5058630015],
              [113.558984992, -26.5762539845],
              [113.635116, -26.613384021],
              [113.750606144, -26.6111230435],
              [113.885214112, -26.502479999],
              [113.883560992, -26.3410090205],
              [113.801889952, -26.254969017],
              [113.69756016, -26.221698987],
              [113.61354912, -26.097858988],
              [113.580050048, -26.096769005],
              [113.559108128, -25.9463979895],
              [113.517617024, -25.919577984500002],
              [113.478696, -25.783336973],
              [113.41447488, -25.7247369835],
              [113.472752032, -25.558263993500002],
              [113.589244064, -25.638044041],
              [113.597835104, -25.6991949955],
              [113.761856864, -25.8785950455],
              [113.734326944, -26.0136579585],
              [113.699923904, -26.044962030500002],
              [113.725299968, -26.2044990005],
              [113.789980064, -26.2074079775],
              [113.880027968, -26.071046013],
              [113.907558944, -26.1132560015],
              [113.975261984, -26.347346991],
              [114.089561984, -26.467616971],
              [114.217270912, -26.3637760455],
              [114.237979904, -26.283905015],
              [114.191178848, -26.168333036],
              [114.25470912, -26.1448920005],
              [114.194657152, -25.985261975500002],
              [114.256916992, -25.989660998],
              [114.233344928, -25.875669955],
              [114.04100592, -25.660185026],
              [113.905400032, -25.413018033],
              [113.810996864, -25.165215990500002],
              [113.697705952, -25.086596041],
              [113.665984928, -25.022706032],
              [113.68636416, -24.929235004],
              [113.61678336, -24.857404758],
              [113.617271936, -24.7363439585],
              [113.406958304, -24.4841762305],
              [113.39164512, -24.222525032500002],
              [113.443342976, -24.1816938675],
              [113.419421984, -24.089203358],
              [113.470909408, -23.9664518805],
              [113.470188416, -23.8993511595],
              [113.56367616, -23.757909021],
              [113.613212864, -23.630907964],
              [113.75533008, -23.525936004],
              [113.779729088, -23.470595011500002],
              [113.791947104, -23.2837820115],
              [113.768585024, -23.1258300105],
              [113.829425984, -23.0309080275],
              [113.817425024, -22.9092949845],
              [113.771424, -22.78526401],
              [113.709393312, -22.715283838],
              [113.654012032, -22.583393009],
              [113.745040448, -22.4520011805],
              [113.832908576, -22.274588604],
              [113.932135936, -21.977174945],
              [113.995084384, -21.875463092],
              [114.165204672, -21.7857607175],
              [114.140753728, -21.943042297],
              [114.08026576, -22.1561650165],
              [114.182367808, -22.343522175500002],
              [114.123078624, -22.4128762705],
              [114.122158912, -22.474367995],
              [114.18199024, -22.5231590625],
              [114.26196976, -22.4406263075],
              [114.368339872, -22.493626014],
              [114.40872, -22.3311670245],
              [114.517338848, -22.066463974],
              [114.615748064, -21.976190005],
              [114.643605952, -21.8489270435],
              [114.76946592, -21.7950859755],
              [114.9147456, -21.6901537535],
              [115.055196128, -21.679612287],
              [115.204046048, -21.598001017],
              [115.307127008, -21.5914799705],
              [115.492746944, -21.4857659755],
              [115.703144352, -21.279463059],
              [115.821504896, -21.2515233045],
              [115.881502464, -21.1211418165],
              [115.989382496, -21.040109245],
              [116.138861984, -20.9936169875],
              [116.191621088, -20.933015039],
              [116.200760032, -20.841663963],
              [116.29759008, -20.8791432425],
              [116.346351008, -20.838822104],
              [116.463440128, -20.8216909745],
              [116.525909152, -20.752860966],
              [116.794022048, -20.659346999500002],
              [116.900452992, -20.7237168985],
              [117.06637184, -20.639543397],
              [117.382811232, -20.7507123205],
              [117.55135136, -20.7066010685],
              [117.630731168, -20.663771034],
              [117.696701568, -20.688020501],
              [117.859989952, -20.603988987],
              [117.87372832, -20.558198231],
              [118.172967104, -20.3509430085],
              [118.212177056, -20.3779634795],
              [118.32787584, -20.3409530085],
              [118.480605504, -20.346761361],
              [118.568751744, -20.2942622275],
              [118.674454848, -20.3322798015],
              [118.821513952, -20.281537983],
              [118.896502112, -20.167756082500002],
              [118.967940992, -20.113634351],
              [118.995389984, -20.034553955],
              [119.09659936, -19.960563242],
              [119.16774, -19.986603028],
              [119.218268864, -19.953213025500002],
              [119.438852128, -20.0161363725],
              [119.57460896, -20.075736213],
              [119.82147792, -19.9718728655],
              [119.972766016, -19.933000573],
              [120.195936, -19.9139079625],
              [120.631002848, -19.770045025],
              [120.96149904, -19.631981967],
              [121.210131968, -19.466301961],
              [121.34189088, -19.331252997],
              [121.511139104, -19.0938719675],
              [121.640875904, -18.8217389655],
              [121.669444064, -18.7190080215],
              [121.789245952, -18.661238016],
              [121.76475408, -18.552827979],
              [121.815213824, -18.451137956],
              [121.908382912, -18.461466987],
              [122.122802144, -18.3105960275],
              [122.21461296, -18.2040360275],
              [122.319110144, -18.165455998],
              [122.380958144, -18.070664033],
              [122.372597152, -17.9937130425],
              [122.207750816, -17.93442452],
              [122.199648832, -17.684822964],
              [122.14516896, -17.560352966],
              [122.150017088, -17.3553720225],
              [122.173206112, -17.2635920055],
              [122.303973952, -17.0605500285],
              [122.424281984, -16.9603479975],
              [122.478231968, -16.9778480355],
              [122.58108, -16.7635960205],
              [122.62389984, -16.797816007],
              [122.737377952, -16.774482956],
              [122.775687008, -16.735473005],
              [122.741798048, -16.6834029605],
              [122.780027168, -16.57875303],
              [122.905775168, -16.485690963],
              [122.991923872, -16.4567700055],
              [122.958415072, -16.5883200275],
              [123.115083104, -16.7137669735],
              [123.152902912, -16.801556041],
              [123.148623968, -16.908677997],
              [123.235535168, -16.970739022],
              [123.290601824, -17.107721014],
              [123.387347872, -17.2493129655],
              [123.392728064, -17.3162529955],
              [123.459279104, -17.3506130085],
              [123.545439008, -17.470141027500002],
              [123.602928128, -17.339400991],
              [123.625116, -17.195731027],
              [123.583543904, -17.033259957],
              [123.64406208, -16.998029001],
              [123.829602848, -17.1346490035],
              [123.797289952, -16.912188002],
              [123.75833904, -16.8377480165],
              [123.563341088, -16.6297460415],
              [123.614682112, -16.553542044],
              [123.491001952, -16.546014986],
              [123.502071968, -16.504064016],
              [123.643023104, -16.5300399955],
              [123.599233088, -16.4487310155],
              [123.671982944, -16.4347599635],
              [123.698871008, -16.3591329625],
              [123.588799904, -16.246644027],
              [123.575609888, -16.1688740415],
              [123.735979072, -16.1522330325],
              [123.878720864, -16.355203026],
              [123.972499072, -16.2728919935],
              [124.125137984, -16.2812320155],
              [124.179148064, -16.309020958],
              [124.223198048, -16.4173210125],
              [124.340596928, -16.424490965],
              [124.387486912, -16.3456200075],
              [124.451426528, -16.409310383],
              [124.703355584, -16.401319197],
              [124.72519536, -16.372198791],
              [124.58358576, -16.3297894465],
              [124.417846784, -16.3588703365],
              [124.383066848, -16.227269994500002],
              [124.46894592, -16.1025689685],
              [124.528646144, -16.162588981],
              [124.58903616, -16.113357983500002],
              [124.607845088, -15.891317006],
              [124.711935104, -15.836975994],
              [124.69940496, -15.7802859815],
              [124.599845152, -15.820737027],
              [124.509966112, -15.988318019],
              [124.483295872, -15.8871079785],
              [124.415625952, -15.8729679845],
              [124.392146048, -15.7455379865],
              [124.445625824, -15.667867975],
              [124.429155104, -15.561026997],
              [124.452024832, -15.4947269745],
              [124.517203904, -15.468626971],
              [124.625174048, -15.511176009],
              [124.668773984, -15.483835987500001],
              [124.70868288, -15.360055022],
              [124.672743008, -15.278995977],
              [124.795232992, -15.2966950195],
              [125.004233152, -15.4410440445],
              [125.073352064, -15.4591839975],
              [125.090850944, -15.354983968500001],
              [125.026372064, -15.300314008],
              [124.92008208, -15.3564650045],
              [124.87614192, -15.3053049565],
              [124.849122112, -15.1497939565],
              [124.911080992, -15.107023973],
              [124.97897088, -15.133604033],
              [125.079000128, -15.0568939865],
              [125.163240128, -15.151363015500001],
              [125.26002, -15.10363296],
              [125.31512016, -15.1546630455],
              [125.382719168, -15.143151957],
              [125.37113904, -14.9966819995],
              [125.30200896, -15.003012958500001],
              [125.272568864, -14.931612985500001],
              [125.317419104, -14.893831971],
              [125.191739168, -14.838613023],
              [125.14252896, -14.752043013],
              [125.234358112, -14.6611819835],
              [125.263636928, -14.589821970500001],
              [125.344506944, -14.550721018],
              [125.411477024, -14.563810989],
              [125.496276128, -14.5123759755],
              [125.56105488, -14.563570045],
              [125.601495104, -14.5274290185],
              [125.621384032, -14.403773964],
              [125.588563904, -14.3699349665],
              [125.592141952, -14.243745967],
              [125.629211872, -14.233575962],
              [125.71634304, -14.311794961],
              [125.66230416, -14.445853028],
              [125.688506048, -14.493426037],
              [125.794595168, -14.466419996],
              [125.83128384, -14.575049998],
              [125.900903872, -14.6315600055],
              [125.916523904, -14.542540022],
              [125.993932928, -14.5550199555],
              [126.04646304, -14.481819988],
              [126.012164032, -14.3954700355],
              [126.069332032, -14.362279019],
              [126.057450944, -14.2556689765],
              [126.12778992, -14.2330480275],
              [126.158957984, -14.1458779885],
              [126.101187008, -14.0748499765],
              [126.034488, -14.0952099665],
              [125.976228128, -14.0396409985],
              [126.08704512, -13.9208399925],
              [126.187035104, -13.968128971],
              [126.217474912, -14.0429289665],
              [126.162105824, -14.057080023500001],
              [126.30188016, -14.228197013],
              [126.35708688, -14.1868970025],
              [126.30104784, -14.1413169615],
              [126.350055008, -14.0490870245],
              [126.486263168, -13.99501602],
              [126.45422496, -14.095605959],
              [126.563294144, -14.1699959945],
              [126.651413888, -14.1734549765],
              [126.83551104, -13.971872964],
              [126.760452128, -13.80821301],
              [126.817239968, -13.7686820435],
              [126.954289088, -13.747572008],
              [127.10284992, -13.884300994],
              [127.225019168, -13.943429991],
              [127.263719168, -13.9014800015],
              [127.34739792, -13.906579045500001],
              [127.466668064, -14.005188985],
              [127.449119168, -14.054058992],
              [127.556777888, -14.104637992],
              [127.670187968, -14.191567013],
              [127.76290704, -14.3037549905],
              [127.819757152, -14.440573979],
              [128.130906944, -14.6641399855],
              [128.183876672, -14.744258953],
              [128.107866592, -14.9469124855],
              [128.075168064, -15.10716387],
              [128.281608128, -15.3459146395],
              [128.300757504, -15.319723912],
              [128.2202376, -15.2037533505],
              [128.194246944, -15.096902993],
              [128.230146272, -15.0006722645],
              [128.35176528, -14.972831892],
              [128.387844992, -14.921751468],
              [128.477134272, -14.911611951],
              [128.436395136, -14.8121510485],
              [128.548014784, -14.770631887],
              [128.688163936, -14.798962972],
              [128.78857296, -14.8598129685],
              [129.001241952, -14.879472863],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Tasmania',
        code: 'tas',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [144.929235008, -40.6223970035],
              [145.014638016, -40.681837004],
              [144.892783008, -40.738997009],
              [144.871830016, -40.6785990045],
              [144.929235008, -40.6223970035],
            ],
          ],
          [
            [
              [148.086981536, -42.697689226499996],
              [148.03070704, -42.621125663],
              [148.119484032, -42.584748706],
              [148.144539552, -42.667306343499995],
              [148.086981536, -42.697689226499996],
            ],
          ],
          [
            [
              [147.305438528, -43.295760982],
              [147.381090048, -43.2097357785],
              [147.288631232, -43.1433159685],
              [147.357056, -43.0635460775],
              [147.432736448, -43.2241493135],
              [147.352198784, -43.267854916],
              [147.379626432, -43.361305631],
              [147.301558016, -43.5104025515],
              [147.178190624, -43.489932283],
              [147.091735456, -43.419737659],
              [147.211925376, -43.382655981499994],
              [147.305438528, -43.295760982],
            ],
          ],
          [
            [
              [148.190719744, -40.3505821645],
              [148.331294752, -40.2951563125],
              [148.4471568, -40.436723733],
              [148.345796672, -40.4919325985],
              [148.31043392, -40.428415827],
              [148.046074976, -40.4487230365],
              [147.985727968, -40.390617237499995],
              [148.127223648, -40.337760092],
              [148.190719744, -40.3505821645],
            ],
          ],
          [
            [
              [147.815305344, -42.899477421499995],
              [147.984179296, -42.890539294499995],
              [147.999509824, -42.9642059245],
              [147.927269216, -43.014224578],
              [147.991513248, -43.154191693],
              [147.944827744, -43.1946156915],
              [147.865652, -43.1692239975],
              [147.777740992, -43.214311994],
              [147.702442016, -43.1773210035],
              [147.618456192, -43.008399964],
              [147.707583392, -43.0067761265],
              [147.845171008, -43.055444002499996],
              [147.815305344, -42.899477421499995],
            ],
          ],
          [
            [
              [144.11357008, -40.008106742],
              [144.102308992, -40.046033],
              [143.921046016, -40.1340809935],
              [143.868816992, -40.063160004],
              [143.891326016, -39.9940580085],
              [143.838703008, -39.9360579925],
              [143.86525456, -39.800365321],
              [143.849262528, -39.7108159045],
              [143.927112288, -39.6620407285],
              [143.94976208, -39.579260943],
              [144.108969056, -39.6691646715],
              [144.11357008, -40.008106742],
            ],
          ],
          [
            [
              [148.177707328, -39.952206846],
              [148.291139872, -39.965366266],
              [148.293434496, -40.1112091475],
              [148.333883424, -40.2095343905],
              [148.210282624, -40.2106947475],
              [148.113556352, -40.271027595],
              [148.04279088, -40.246282291],
              [148.006263808, -40.104510704499994],
              [147.90323216, -39.991984399],
              [147.839858784, -39.836094001],
              [147.941838816, -39.7195459805],
              [148.177707328, -39.952206846],
            ],
          ],
          [
            [
              [147.700692544, -42.871390499499995],
              [147.61080624, -42.8651533725],
              [147.59605008, -42.807737975],
              [147.486063552, -42.8025197355],
              [147.479925888, -42.9067394485],
              [147.417202272, -42.907720744],
              [147.327971104, -42.977706096],
              [147.337668544, -43.04189007],
              [147.238930368, -43.154085651],
              [147.24229136, -43.2679733345],
              [147.09923424, -43.283113438499996],
              [146.979584128, -43.470412433499995],
              [146.89053296, -43.535645339],
              [146.920965216, -43.600042211],
              [146.724595968, -43.630693473499996],
              [146.552291904, -43.5120980025],
              [146.401532832, -43.5382194475],
              [146.211946464, -43.48791693],
              [146.036828, -43.551721321],
              [146.032044128, -43.4680977505],
              [145.97286704, -43.404442025499996],
              [146.030175936, -43.342215314499995],
              [145.9600712, -43.292083774],
              [145.871302464, -43.321938149],
              [145.79423696, -43.192726915499996],
              [145.591095072, -42.974961084499995],
              [145.500283808, -42.985500830499994],
              [145.366683104, -42.657903404],
              [145.332710016, -42.65313588],
              [145.235871584, -42.4712649145],
              [145.212905632, -42.2969498115],
              [145.310017824, -42.3204398535],
              [145.513124544, -42.4347524265],
              [145.54450848, -42.3850446655],
              [145.467787936, -42.3465529365],
              [145.361744064, -42.232503267],
              [145.359657664, -42.177351844],
              [145.256774688, -42.178151469499994],
              [145.251882816, -42.0520360075],
              [145.199057376, -41.951356547],
              [145.071742496, -41.854825656],
              [144.927195456, -41.675946251499994],
              [144.784786016, -41.445208997499996],
              [144.771620992, -41.355484996499996],
              [144.684335008, -41.234478994],
              [144.613772, -40.935958998],
              [144.713188992, -40.8532879925],
              [144.692398016, -40.6634339995],
              [144.841586016, -40.737398997499994],
              [144.990941792, -40.7511049815],
              [145.125249568, -40.832546366],
              [145.269071936, -40.8110545645],
              [145.339984864, -40.849942841],
              [145.488740992, -40.866465857],
              [145.560078912, -40.915575143],
              [145.731939648, -40.9468609],
              [145.800868512, -41.026184497],
              [145.962042944, -41.063913101],
              [146.168952416, -41.150126209],
              [146.391883008, -41.172958002499996],
              [146.544479168, -41.126951462499996],
              [146.558941024, -41.164928577],
              [146.713539008, -41.0741019945],
              [146.805426016, -41.063562008],
              [146.999436992, -40.983819996499996],
              [147.147498528, -41.012818339499994],
              [147.249210848, -40.953905515],
              [147.346040736, -40.939753218499995],
              [147.396413216, -41.004883782],
              [147.490727712, -40.979349305],
              [147.598875072, -40.855588375],
              [147.661333216, -40.824983140499995],
              [147.83582352, -40.886976844],
              [147.890708224, -40.860076327],
              [147.97503152, -40.7391468775],
              [148.079580352, -40.7692863005],
              [148.114444384, -40.8308008725],
              [148.22368032, -40.847675814],
              [148.339854784, -40.994240362],
              [148.271076416, -41.11841214],
              [148.3139616, -41.345548591],
              [148.262955744, -41.4602341055],
              [148.32029552, -41.621392175],
              [148.267856384, -41.8363265995],
              [148.32358992, -41.917201458499996],
              [148.28375408, -42.0037863425],
              [148.355714496, -42.1933267235],
              [148.31458832, -42.2758248835],
              [148.261503072, -42.2543840125],
              [148.29443504, -42.124585922],
              [148.162227104, -42.077949327499994],
              [148.072221024, -42.115064453],
              [148.013418464, -42.2396712215],
              [148.024556992, -42.3427450075],
              [147.980502976, -42.4053512275],
              [148.009132, -42.461293433],
              [147.955126976, -42.550903511],
              [147.945891776, -42.725091907499994],
              [147.8874976, -42.7570152115],
              [147.827177888, -42.8804515405],
              [147.700692544, -42.871390499499995],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Northern Territory',
        code: 'nt',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [136.598106624, -15.592936907],
              [136.589686848, -15.645317326],
              [136.510927776, -15.626348018],
              [136.511887776, -15.543436938],
              [136.60960672, -15.523155517500001],
              [136.598106624, -15.592936907],
            ],
          ],
          [
            [
              [136.71466096, -11.1775398905],
              [136.6242744, -11.3287095325],
              [136.587873728, -11.278890087],
              [136.663471552, -11.18407015],
              [136.71466096, -11.1775398905],
            ],
          ],
          [
            [
              [136.189085952, -13.7948059675],
              [136.135396736, -13.837086293],
              [136.10916672, -13.742206934],
              [136.172026016, -13.749226315],
              [136.199615456, -13.665286487],
              [136.25480496, -13.6759860175],
              [136.254164896, -13.832985046500001],
              [136.189085952, -13.7948059675],
            ],
          ],
          [
            [
              [136.949155136, -15.729082662],
              [136.949934848, -15.6546622865],
              [137.000434208, -15.620941633500001],
              [137.08166368, -15.655770714],
              [137.097364352, -15.812391196],
              [137.039254912, -15.834392025],
              [136.949155136, -15.729082662],
            ],
          ],
          [
            [
              [135.559419296, -12.0384879325],
              [135.592879296, -11.952455736],
              [135.677738784, -11.9327351615],
              [135.734059296, -12.001904719],
              [135.559419296, -12.0384879325],
            ],
          ],
          [
            [
              [132.583946976, -11.1448648575],
              [132.619375776, -11.284766168],
              [132.587566048, -11.3436164625],
              [132.500186784, -11.204145536],
              [132.50428656, -11.057675745],
              [132.579045952, -11.0046258665],
              [132.583946976, -11.1448648575],
            ],
          ],
          [
            [
              [130.638036032, -11.751749273],
              [130.606422048, -11.8265353565],
              [130.4974344, -11.8289276655],
              [130.312258976, -11.7708917225],
              [130.118193376, -11.8271248775],
              [130.030814272, -11.806245722],
              [130.084992992, -11.669305799],
              [130.157252192, -11.7050648005],
              [130.202311264, -11.6494344125],
              [130.169140736, -11.462725604500001],
              [130.247679424, -11.3545154415],
              [130.340068384, -11.318724731],
              [130.40013792, -11.425023233500001],
              [130.376167968, -11.5070025795],
              [130.464295616, -11.576139392],
              [130.468346112, -11.666179373],
              [130.638036032, -11.751749273],
            ],
          ],
          [
            [
              [136.418761472, -13.857992995],
              [136.624415936, -13.790771099],
              [136.6810744, -13.7394207045],
              [136.728912352, -13.8191495255],
              [136.837317568, -13.842907429],
              [136.85741568, -13.9108262385],
              [136.77088896, -13.9511269715],
              [136.77897872, -14.023926821],
              [136.70033088, -14.111097267],
              [136.726250496, -14.189166527],
              [136.895567136, -14.201584781500001],
              [136.956236224, -14.2467639645],
              [136.890897408, -14.307914179],
              [136.736010368, -14.2595759915],
              [136.649892064, -14.296216703],
              [136.624122912, -14.2638872685],
              [136.490815968, -14.2370090625],
              [136.397998912, -14.17790073],
              [136.44291824, -14.115330659],
              [136.408151168, -13.976332019],
              [136.418761472, -13.857992995],
            ],
          ],
          [
            [
              [130.679582976, -11.442745697],
              [130.704561888, -11.385318441],
              [130.84238992, -11.358626974],
              [130.895249312, -11.309356738],
              [131.031606848, -11.3672930215],
              [131.040937216, -11.317754295],
              [131.147746784, -11.249875131],
              [131.288205504, -11.193864642],
              [131.374954592, -11.2642828385],
              [131.416984256, -11.257692565],
              [131.473513536, -11.395130434],
              [131.537893056, -11.4149199025],
              [131.530263072, -11.4733797175],
              [131.460793408, -11.51285955],
              [131.471643296, -11.6059593015],
              [131.371633984, -11.6054491085],
              [131.333964416, -11.6792590395],
              [131.181905472, -11.791748974],
              [131.081916, -11.8362092285],
              [130.943566944, -11.9367898435],
              [130.86228768, -11.854650787],
              [130.686340608, -11.7964438115],
              [130.55635376, -11.6724268785],
              [130.492625344, -11.6549286165],
              [130.492464608, -11.563858389],
              [130.43186672, -11.50256134],
              [130.407147616, -11.300144145],
              [130.363497952, -11.251204948],
              [130.401657248, -11.166135214],
              [130.512505888, -11.284972887],
              [130.55184528, -11.2667625785],
              [130.58132448, -11.402440524],
              [130.641683264, -11.3692998275],
              [130.679582976, -11.442745697],
            ],
          ],
          [
            [
              [129.001241952, -14.879472863],
              [129.065941824, -14.891073658],
              [129.188449536, -14.9864931245],
              [129.169509088, -15.0515325015],
              [129.238088992, -15.128740531],
              [129.225277856, -14.840602624],
              [129.31649712, -14.859392112],
              [129.474927744, -14.9366296675],
              [129.603902784, -15.1080064525],
              [129.641612352, -15.079026554],
              [129.592117088, -14.8910090375],
              [129.672400704, -14.763467873],
              [129.58513488, -14.6138290135],
              [129.3841552, -14.4199900835],
              [129.366654816, -14.3396801775],
              [129.409293952, -14.2359399475],
              [129.46330336, -14.193129634],
              [129.514142176, -14.0703990245],
              [129.594868448, -14.0912312825],
              [129.611677536, -14.0535805635],
              [129.725935744, -14.0091395305],
              [129.752155072, -13.9507289995],
              [129.722564704, -13.847909755],
              [129.79401344, -13.7792392905],
              [129.790163328, -13.666909843500001],
              [129.826111872, -13.510230328],
              [129.900510816, -13.498599748],
              [130.008369312, -13.5333385115],
              [130.14160656, -13.4571171795],
              [130.235484448, -13.339676275],
              [130.23473424, -13.277077048],
              [130.160274912, -13.175108748],
              [130.11617552, -13.164139173],
              [130.141113568, -12.933457992500001],
              [130.2225824, -12.9491676375],
              [130.338699936, -12.889326631],
              [130.352028544, -12.670337376500001],
              [130.440045856, -12.6342161635],
              [130.5201552, -12.70358578],
              [130.58459312, -12.680714637],
              [130.556931744, -12.625593868500001],
              [130.619759872, -12.3848725715],
              [130.752948256, -12.4288008215],
              [130.769418848, -12.527071471],
              [130.88533888, -12.575351698],
              [130.896507968, -12.4683404645],
              [130.82754288, -12.4495203775],
              [130.894396992, -12.3311897155],
              [131.012977152, -12.323279448500001],
              [131.065336128, -12.1668090755],
              [131.169535488, -12.1836088515],
              [131.225045472, -12.2320189855],
              [131.288985856, -12.046368951],
              [131.320925344, -12.0908789705],
              [131.3278448, -12.2023391765],
              [131.396175136, -12.2641105655],
              [131.472295424, -12.2837117965],
              [131.75454016, -12.2739006545],
              [131.871229184, -12.2164009525],
              [131.939407776, -12.27293094],
              [132.069714304, -12.30353993],
              [132.173222656, -12.211710296],
              [132.261722688, -12.173431132],
              [132.278462752, -12.224211375],
              [132.353163616, -12.198822567],
              [132.389393088, -12.236412717],
              [132.44396288, -12.145463146500001],
              [132.629281056, -12.085414977],
              [132.6189616, -12.0178450775],
              [132.65532256, -11.8898153835],
              [132.620603648, -11.7581453335],
              [132.49984528, -11.6821148475],
              [132.551025376, -11.6113954895],
              [132.457146784, -11.4577553575],
              [132.353457376, -11.4412742995],
              [132.2332584, -11.4568631025],
              [132.077929632, -11.529341718],
              [132.007499904, -11.4308414835],
              [131.939010304, -11.393791182],
              [131.972880128, -11.344651926],
              [131.859750912, -11.2927823475],
              [131.840041088, -11.2265631885],
              [132.017350368, -11.1456038955],
              [132.065629888, -11.1844735425],
              [132.145388928, -11.356382739],
              [132.191958656, -11.29304329],
              [132.206019072, -11.17839398],
              [132.304208512, -11.1727445425],
              [132.444987296, -11.2142152155],
              [132.506786784, -11.2722755785],
              [132.501876768, -11.3299358235],
              [132.622015744, -11.410267134],
              [132.667235136, -11.514906908],
              [132.732874784, -11.5190771965],
              [132.784314368, -11.4459172445],
              [132.916922624, -11.3317251805],
              [133.00785184, -11.4328253125],
              [133.158921472, -11.7100468505],
              [133.308089312, -11.738985716],
              [133.322378752, -11.7704154955],
              [133.461517056, -11.801744635],
              [133.602136256, -11.809163893500001],
              [133.62612624, -11.837213871],
              [133.834844224, -11.722992096],
              [133.889864544, -11.8123715715],
              [133.823085024, -11.838102241],
              [133.876015264, -11.910521786],
              [134.00378448, -11.864570413],
              [134.132314272, -11.902029046500001],
              [134.156364896, -11.993748846],
              [134.253514848, -12.034147555],
              [134.28527424, -11.983347202500001],
              [134.34803456, -12.039126404500001],
              [134.481144416, -12.0738349575],
              [134.603003808, -12.0496837625],
              [134.687492672, -11.966112954],
              [134.770002304, -11.958432087],
              [134.842653632, -12.114081245],
              [134.9475736, -12.1452202415],
              [135.056034432, -12.263609456],
              [135.166104128, -12.2658385395],
              [135.265093376, -12.2244779045],
              [135.305992096, -12.124337626500001],
              [135.366211456, -12.0847172495],
              [135.463561408, -12.111916597],
              [135.520760704, -12.061506206],
              [135.57001104, -12.100745964],
              [135.727399424, -12.0091447495],
              [135.77275968, -12.0439444705],
              [135.650051552, -12.1684754075],
              [135.676822368, -12.241725177],
              [135.778941792, -12.223704364],
              [135.91038992, -12.151673504],
              [135.97049152, -12.273472805],
              [136.033911168, -12.271002407500001],
              [135.975603104, -12.3951126545],
              [136.03170384, -12.4740422755],
              [136.063023136, -12.434422139],
              [136.23366368, -12.456560275],
              [136.304793024, -12.399069564],
              [136.362770912, -12.257499054],
              [136.325639904, -12.2025495215],
              [136.228270144, -12.2131906105],
              [136.197269312, -12.162050968],
              [136.265028096, -12.067390131],
              [136.341217792, -12.056799251],
              [136.451656096, -11.939667907],
              [136.494106976, -12.023907472],
              [136.531076448, -11.9914370305],
              [136.590307712, -12.09510635],
              [136.578098496, -12.1490565125],
              [136.647500608, -12.2697155845],
              [136.74825008, -12.266534343],
              [136.702902976, -12.186952671],
              [136.782358272, -12.159093928],
              [136.928108576, -12.282722398],
              [136.903599616, -12.389052628],
              [136.729532928, -12.478324489],
              [136.73542384, -12.5791743715],
              [136.675345664, -12.70439497],
              [136.631275872, -12.7002454385],
              [136.590806976, -12.7801057575],
              [136.48670784, -12.799886716],
              [136.54338832, -12.9096359495],
              [136.508589056, -12.9985559775],
              [136.538979392, -13.110765304],
              [136.479310048, -13.1696755755],
              [136.475590336, -13.2343153895],
              [136.387371168, -13.230336169],
              [136.356140832, -13.147776737],
              [136.365650208, -13.057557065500001],
              [136.308780864, -13.0714874545],
              [136.296461408, -13.168817175500001],
              [136.200682432, -13.247207688],
              [136.049933056, -13.2410590835],
              [136.00359296, -13.212649725],
              [135.918433696, -13.270450329500001],
              [135.862895488, -13.435170056],
              [135.83973696, -13.566359587],
              [135.914498016, -13.7472385085],
              [136.034257088, -13.7164775595],
              [136.015037984, -13.830947401],
              [135.917549376, -13.977927607],
              [135.88145008, -14.1812768135],
              [135.78894144, -14.2319373985],
              [135.653962912, -14.418397363],
              [135.618363264, -14.428707524],
              [135.53719408, -14.5597775635],
              [135.519114208, -14.6532872565],
              [135.465004704, -14.675787419],
              [135.393785376, -14.771877399500001],
              [135.40932528, -14.8643768815],
              [135.4704648, -14.9702259265],
              [135.579953568, -15.0453051425],
              [135.639732864, -15.0444449665],
              [135.724141728, -15.116294064],
              [135.853229824, -15.177462723],
              [135.925168352, -15.249211828],
              [136.164673024, -15.3923390205],
              [136.239711616, -15.416088118],
              [136.290011424, -15.571988617],
              [136.412069856, -15.626158134],
              [136.560187424, -15.727128137],
              [136.644066848, -15.6724464475],
              [136.72459664, -15.6976952475],
              [136.670497216, -15.794146866],
              [136.729497376, -15.932397477],
              [136.769496992, -15.8896664915],
              [136.906256512, -15.927004634500001],
              [136.98183552, -15.8535529005],
              [137.083575296, -15.944162071],
              [137.250574336, -16.0098400865],
              [137.308454528, -16.0900894975],
              [137.40919408, -16.144318066500002],
              [137.601541856, -16.1849024045],
              [137.729670976, -16.2322515635],
              [137.862020864, -16.422710488],
              [138.001180288, -16.5445094745],
              [138.00119728, -17.210267402],
              [138.001195744, -17.822506735],
              [138.00119696, -18.646506318],
              [137.996615616, -18.868219272],
              [137.996242208, -19.602136768],
              [137.99659712, -20.2563765585],
              [137.99720352, -21.2563357465],
              [137.997568288, -21.8396459635],
              [137.998004064, -22.5792390375],
              [137.998402752, -23.499857294],
              [137.99854816, -24.083167992],
              [137.99870368, -24.666468885],
              [137.998899296, -25.416447859],
              [137.999053824, -25.99686697],
              [137.165896128, -25.997557168],
              [136.582592864, -25.998043089],
              [135.877277024, -25.998526975],
              [135.263283264, -25.998535411],
              [134.533289984, -25.998543292],
              [133.947292256, -25.998546659],
              [132.993366944, -25.998572522],
              [132.52720848, -25.998577221],
              [131.498454016, -25.998587803],
              [130.871560224, -25.998593316],
              [129.81131744, -25.9985797555],
              [129.001853696, -25.9986126115],
              [129.000699648, -24.9153040785],
              [129.000752736, -24.331991216],
              [129.001306112, -23.4319193925],
              [129.001301856, -22.9985751705],
              [129.001014944, -21.9985755045],
              [129.001289344, -20.9985791315],
              [129.001278848, -19.998564536],
              [129.000521536, -19.0839349885],
              [129.000514688, -18.148128269],
              [129.000496736, -17.372407396],
              [129.000489856, -16.7812583405],
              [129.000486144, -16.199583912],
              [129.000439712, -15.3874385925],
              [129.001241952, -14.879472863],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Australian Capital Territory',
        code: 'act',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [148.804045472, -35.7139670135],
            [148.762674816, -35.495504879500004],
            [148.810040608, -35.3074120495],
            [149.120901888, -35.124517275500004],
            [149.271627616, -35.270804786],
            [149.249307616, -35.330127219],
            [149.13866688, -35.428319114],
            [149.14048576, -35.5882919995],
            [149.078042688, -35.5861274995],
            [149.109483008, -35.696639599],
            [149.100583264, -35.814811198],
            [149.046080448, -35.920762215],
            [148.912654464, -35.8554600825],
            [148.89777568, -35.794650157],
            [148.804045472, -35.7139670135],
          ],
        ],
      },
    },
  ],
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/GraphAustralia/AustraliaGeoJson.ts